import { render, staticRenderFns } from "./tabbedSection.vue?vue&type=template&id=3ee20540&"
import script from "./tabbedSection.vue?vue&type=script&lang=js&"
export * from "./tabbedSection.vue?vue&type=script&lang=js&"
import style0 from "./tabbedSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabbedSection.vue"
export default component.exports